export const isMainIframe = !location.href.includes('#');
